type DotNetCallbackObjectRef = {
  invokeMethodAsync: (methodName: string, ...args: unknown[]) => Promise<void>
}

type StickyHandle = {
  dispose: () => void
}

const installBlazorBridge = () => {
  window.subscribeModalHidden = (modal, dotNetCallbackObjectRef) => {
    modal.addEventListener('hidden.bs.modal', async () => {
      await dotNetCallbackObjectRef.invokeMethodAsync('OnModalHidden')
    })
  }

  window.subscribeModalShow = (modal, dotNetCallbackObjectRef) => {
    modal.addEventListener('show.bs.modal', async () => {
      await dotNetCallbackObjectRef.invokeMethodAsync('OnModalShow')
    })
  }

  window.subscribePortfolioAccountPageSetAccount = (dotNetCallbackObjectRef) => {
    window.notifyInitializePortfolioAccountPage = async (account) => {
      await dotNetCallbackObjectRef.invokeMethodAsync('SetAccount', account)
    }
  }

  window.subscribeInstruments = (dotNetCallbackObjectRef) => {
    window.notifyNewFavouriteInstrument = async (newInstrumentFigi, type) => {
      await dotNetCallbackObjectRef.invokeMethodAsync('AddNewInstrument', newInstrumentFigi, type)
    }
  }

  window.makeSticky = (element) => {
    element.classList.add('polab-sticky')

    return {
      dispose: () => element.classList.remove('polab-sticky'),
    }
  }
}

declare global {
  interface Window {
    subscribeModalHidden: (
      modal: HTMLDivElement,
      dotNetCallbackObjectRef: DotNetCallbackObjectRef
    ) => void
    subscribeModalShow: (
      modal: HTMLDivElement,
      dotNetCallbackObjectRef: DotNetCallbackObjectRef
    ) => void
    subscribeInstruments: (dotNetCallbackObjectRef: DotNetCallbackObjectRef) => void
    subscribePortfolioAccountPageSetAccount: (
      dotNetCallbackObjectRef: DotNetCallbackObjectRef
    ) => void
    makeSticky: (element: HTMLElement) => StickyHandle
    notifyOnPortfolioChanged: () => void
    notifyNewFavouriteInstrument: (newInstrumentFigi: string, type: string) => void
    notifyInitializePortfolioAccountPage: (account: string) => void
  }
}

export {installBlazorBridge}
